import interpolateComponents from '@automattic/interpolate-components';
import { sprintf } from 'sprintf-js';

import { H2 } from 'components/Text/H2';
import { H3 } from 'components/Text/H3';
import { Underline } from 'components/Text/Underline';
import { MainChartData } from 'modules/salaries/types/MainChartData';

import { ChartTextContainer } from './MainChartHeader.styled';

type Props = {
  data: MainChartData;
  initialized: boolean;
  loading: boolean;
};

export function MainChartHeader({ data, initialized, loading }: Props) {
  let headingText = 'Loading... please wait';
  let subHeadingText = '';

  if (!loading && data === null && initialized) {
    headingText = getText('We are still a work {{s}}in progress{{/s}}');
    subHeadingText = getText(
      "We don't have enough data about this job title, please try another combination of information",
    );
  }

  if (!loading && data && initialized) {
    const { filtersUsed = {}, submittedData = {} } = data;
    const locationFilterApplied =
      filtersUsed && filtersUsed.cityBucket === 'CITY' && submittedData.city;

    headingText = locationFilterApplied
      ? sprintf(
          getText('{{s}}%(jobTitle)s{{/s}} Salaries in %(workLocation)s'),
          {
            jobTitle: submittedData.jobTitleSelected,
            workLocation: `${submittedData.city}, ${submittedData.stateCode}`,
          },
        )
      : sprintf(getText('{{s}}%(jobTitle)s{{/s}} Salaries'), {
          jobTitle: submittedData.jobTitleSelected,
        });
    subHeadingText = '';
  }

  if (!loading && !initialized) {
    headingText = getText('You Should Be {{s}}Paid Fairly{{/s}}');
    subHeadingText = getText(
      'Learn what people at nonprofits earn, in different jobs, different cities, and more!',
    );
  }

  return (
    <ChartTextContainer>
      <H2 mb={0}>
        {interpolateComponents({
          mixedString: headingText,
          components: {
            s: <Underline />,
          },
        })}
      </H2>
      {subHeadingText ? <H3 mb={0}>{subHeadingText}</H3> : null}
    </ChartTextContainer>
  );
}
